import $ from 'jquery'

const $html = $('html')
const LOCKED_CLASS = '-is-locked'

export const lockScreen = () => {
  const top = $(window).scrollTop()

  if (!$html.hasClass(LOCKED_CLASS)) {
    $html
      .addClass(LOCKED_CLASS)
      .css({ top: top * -1 })
      .data('top', top)
  }
}

export const unlockScreen = () => {
  const top = $html.data('top') || 0

  if ($html.hasClass(LOCKED_CLASS)) {
    $html.removeClass(LOCKED_CLASS).css({ top: '' })
    $(window).scrollTop(top)
  }
}
